export default "__VITE_ASSET__AicKy6XF__"